module.exports = __webpack_public_path__ + "static/media/SerendipityThree-Regular.623409ce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SerendipityThree-Regular.ttf
// module id = 3729
// module chunks = 68